// local or tesing url
// export const base_url = "https://pguat.safexpay.com/agadmin/";
// export const client_Id =
//   "AIWGHRF44EKIQLZQY35MX9AR36ZK7TF1:RNOX2JP1HEDMOVHEOCARY2LSCLUM2RCP";
// export const client_Secret = "RNOX2JP1HEDMOVHEOCARY2LSCLUM2RCP";
export const merchant_url =
  "https://pguat.safexpay.com/agmerchant/paygateIndex.jsp";

// Production url
//export const base_url = "https://www.avantgardepayments.com/agadmin/";
//export const base_url = "http://localhost:8080/agadmin/";
export const base_url = "https://pguat.safexpay.com/agadmin/";
export const client_Id =
  "AIFCJKOC5UIJADELNOK7CGJM63BCKJFW:A12GXN9FRI1DMHUZ99HY2IH8M4B7SW8B";
export const client_Secret = "A12GXN9FRI1DMHUZ99HY2IH8M4B7SW8B";
// export const merchant_url =
//   "http://localhost:8080/agmerchant/paygateIndex.jsp";
